import React, { useEffect, useState } from "react";
import { Loader2, Printer } from "lucide-react";
import api, { apiError, MONTHS } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import Payslip from "@/components/Payslip";

export default function SlipGajiTab() {
  const now = new Date();
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState("");
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [year] = useState(now.getFullYear());
  const [slip, setSlip] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get("/users").then((r) => { setUsers(r.data); if (r.data[0]) setUserId(r.data[0].id); }); }, []);

  const generate = async () => {
    if (!userId) return toast.error("Pilih karyawan");
    setLoading(true);
    try {
      const { data } = await api.get(`/payroll?user_id=${userId}&month=${month}&year=${year}`);
      setSlip(data);
    } catch (e) { toast.error(apiError(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="space-y-5">
      <h2 className="text-xl font-bold text-slate-800 no-print">Slip Gaji</h2>

      <div className="bg-white rounded-2xl border border-slate-200 p-5 no-print">
        <div className="grid sm:grid-cols-3 gap-3 items-end">
          <div className="space-y-1.5"><Label>Karyawan</Label>
            <Select value={userId} onValueChange={setUserId}>
              <SelectTrigger data-testid="slip-user-select"><SelectValue placeholder="Pilih" /></SelectTrigger>
              <SelectContent>{users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>)}</SelectContent>
            </Select></div>
          <div className="space-y-1.5"><Label>Bulan</Label>
            <Select value={String(month)} onValueChange={(v) => setMonth(Number(v))}>
              <SelectTrigger data-testid="slip-month-select"><SelectValue /></SelectTrigger>
              <SelectContent>{MONTHS.map((m, i) => <SelectItem key={i} value={String(i + 1)}>{m} {year}</SelectItem>)}</SelectContent>
            </Select></div>
          <Button data-testid="generate-slip-button" onClick={generate} disabled={loading} className="bg-[#3368A0] hover:bg-[#284f7a]">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Tampilkan Slip"}
          </Button>
        </div>
      </div>

      {slip && (
        <>
          <div className="flex justify-end no-print">
            <Button data-testid="print-payslip-button" onClick={() => window.print()} className="bg-[#66A3BF] hover:bg-[#5590ab]">
              <Printer className="h-4 w-4 mr-1.5" /> Cetak / Download Slip Gaji
            </Button>
          </div>

          <Payslip slip={slip} />
        </>
      )}
    </div>
  );
}
